<template>
  <div class="student_detaill_dialog">
    <el-dialog
      title="查看详情"
      :visible.sync="expertDetailDialog"
      width="60%"
      class="dialog_title"
    >
      <!-- /基本信息    -->
      <div class="open-header">基本信息</div>
      <el-form size="small" label-width="138px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名：">{{ info.username }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 性别 0未填 1男 2女 -->
            <el-form-item label="性别：">{{ info.sex }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号：">{{ info.phone }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学历学位：">{{ info.edus }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="籍贯："
              >{{ info.area_province_id }}/{{ info.area_city_id }}</el-form-item
            >
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作单位：">{{ info.org_name }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作单位所属阶段：">{{
              info.stage_id
            }}</el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="现任专业技术职务：">{{
              info.profession_duty
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="现任行政职务：">{{
              info.administration_duty
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 数字 -->
            <el-form-item label="职称：">{{ info.rank_id }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="现任教学段：">{{
              info.now_subjects
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可任教学科：">{{
              info.can_subjects
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可任教学段：">{{
              info.can_stages
            }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="教龄：">{{ info.work_year }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="研究方向：">{{ info.research }} </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="擅长领域：">{{ info.skill }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="简介：">{{ info.introduction }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 教学统计    -->
      <div class="open-header">教学统计</div>

      <el-form size="small" label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="面授课：">{{
              statistics.face_num
            }}</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="本班级满意度：">{{
              statistics.whole
            }}%</el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台满意度：">{{
              statistics.project_whole
            }}%</el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="flex_end">
        <el-button @click="cancel" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ExpertsDetail } from "@/api/tearcher";
export default {
  data() {
    return {
      expertDetailDialog: false,
      info: {},
      statistics: {},
    };
  },
  methods: {
    // 操作dialog
    operationDialog(row, class_id) {
      this.expertDetailDialog = true;
      // this.type = type;
      ExpertsDetail({ class_id: class_id, experts: row.experts }).then(
        (res) => {
          let { info, statistics } = res.data;
          this.statistics = statistics;
          this.info = info;
        }
      );
    },
    // 取消按钮
    cancel() {
      this.expertDetailDialog = false;
    },
  },
};
</script>
 
<style lang = "less" scoped>
.student_detaill_dialog {
  .open-header {
    font-size: 18px;
    margin-bottom: 10px;
    margin-left: 15px;
    color: #303133;
  }
  /deep/ .el-form {
    .el-form-item__label {
      padding: 0 4px 0;
    }
  }
}
</style>